import { SvgIcon, SvgIconProps } from "@mui/material";

export const CustomEmail = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 52 48">
      <path fill="url(#a)" d="M0 16h52v32H0z" />
      <rect width="38" height="22" x="7" y="16" fill="#FCF7ED" rx="1" />
      <path fill="#31BEEF" d="m0 16 18.239 12L52 48H0V16Z" />
      <path fill="#37BDF4" d="M52 16 33.761 28 0 48h52V16Z" />
      <path
        fill="url(#b)"
        d="M24.428.968a3 3 0 0 1 3.144 0L52 16H0L24.428.968Z"
      />
      <path fill="#0985DB" d="M26 32.5 52 48H0l26-15.5Z" />
      <defs>
        <linearGradient
          id="a"
          x1="25.037"
          x2="26.075"
          y1="26"
          y2="8.504"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".035" stop-color="#056BBA" />
          <stop offset="1" stop-color="#023054" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="26"
          x2="31.692"
          y1="1"
          y2="26.913"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#056BBA" />
          <stop offset="1" stop-color="#023054" />
        </linearGradient>
      </defs>
    </svg>
  </SvgIcon>
);
